import React, { memo } from 'react';

import classes from './FullScreenOverlay.module.scss';

const FullScreenOverlay = ({ onClick, show }) => {
  return show ? <div onClick={onClick} className={classes.FullScreenOverlay} /> : null;
};

export default memo(FullScreenOverlay);
